module.exports = __webpack_public_path__ + "img/the-mover.a1dc8b71.png";